module.exports = __webpack_public_path__ + "static/img/logo.1b44bb4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.svg
// module id = AqYs
// module chunks = 0